import axios from 'axios';

// Action types
export const FETCH_VOUCHER_PRODUCTS = 'FETCH_VOUCHER_PRODUCTS';
export const FETCH_VOUCHER_BALANCE = 'FETCH_VOUCHER_BALANCE';
export const FETCH_VOUCHERS = 'FETCH_VOUCHERS';
export const INITIATE_VOUCHER_PURCHASE = 'INITIATE_VOUCHER_PURCHASE';
export const COMPLETE_VOUCHER_PURCHASE = 'COMPLETE_VOUCHER_PURCHASE';
export const CLEAR_VOUCHER_ERRORS = 'CLEAR_VOUCHER_ERRORS';
export const SET_SELECTED_VOUCHER_PRODUCT = 'SET_SELECTED_VOUCHER_PRODUCT';

// Fetch available voucher products for purchase
export function fetchVoucherProducts() {
  return {
    type: FETCH_VOUCHER_PRODUCTS,
    payload: axios.get('/api/v3/vouchers/products'),
  };
}

// Fetch customer's voucher balance
export function fetchVoucherBalance() {
  return {
    type: FETCH_VOUCHER_BALANCE,
    payload: axios.get('/api/v3/vouchers/balance'),
  };
}

// Fetch customer's vouchers with details
export function fetchVouchers() {
  return {
    type: FETCH_VOUCHERS,
    payload: axios.get('/api/v3/vouchers'),
  };
}

// Initiate voucher purchase - creates Stripe checkout session
export function initiateVoucherPurchase(voucherProductId, termsAccepted) {
  return {
    type: INITIATE_VOUCHER_PURCHASE,
    payload: axios.post('/api/v3/vouchers/purchase', {
      voucher_product_id: voucherProductId,
      terms_accepted: termsAccepted,
    }),
  };
}

// Complete voucher purchase after Stripe redirect
export function completeVoucherPurchase(sessionId) {
  return {
    type: COMPLETE_VOUCHER_PURCHASE,
    payload: axios.post('/api/v3/vouchers/purchase_success', {
      session_id: sessionId,
    }),
  };
}

// Clear any voucher errors
export function clearVoucherErrors() {
  return {
    type: CLEAR_VOUCHER_ERRORS,
  };
}

// Set selected voucher product for purchase flow
export function setSelectedVoucherProduct(product) {
  return {
    type: SET_SELECTED_VOUCHER_PRODUCT,
    payload: product,
  };
}
